import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { SharedHttp } from '../../services/http-client.service';
import { ComponentService } from '../../services/component.service';
import { LoginComponent } from '../login';
import { UtilityService } from '../../services/utility.service';
import { DomSanitizer } from '@angular/platform-browser';
import { WebsiteThemeService } from '../../services/website-theme.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateObjectPipe } from '../../pipes/translate-object.pipe';
import { WebClientService } from '../../services/webclient-settings.service';
import { load } from 'recaptcha-v3';
import { SuccessfulRegistrationComponent } from './successful-registration/successful-registration.component';
import { CompanyLocationInformationComponent } from './legal-entity-registration/company-location-information/company-location-information.component';
import { GeneralCompanyInformationComponent } from './legal-entity-registration/general-company-information/general-company-information.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { LanguageService } from "../../services/language.service";
import { EmailGoogleRegistrationComponent } from "./email-google-registration/email-google-registration.component";
import { AuthService } from "../../services/auth.service";
import { GoogleAnalyticsService } from "../../services/google-analytics.service";
/**
 * Register Component
 */
let RegisterComponent = class RegisterComponent {
    constructor(httpClient, compService, utility, sanitizer, themeService, router, translateObjectPipe, webSettingsService, formBuilder, languageService, route, auth, googleAnalyticsService) {
        this.httpClient = httpClient;
        this.compService = compService;
        this.utility = utility;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.router = router;
        this.translateObjectPipe = translateObjectPipe;
        this.webSettingsService = webSettingsService;
        this.formBuilder = formBuilder;
        this.languageService = languageService;
        this.route = route;
        this.auth = auth;
        this.googleAnalyticsService = googleAnalyticsService;
        this.passwordsSame = true;
        this.phoneError = false;
        this.userTypeError = false;
        this.passwordNotStrong = false;
        this.countries = [];
        this.secondColor = '';
        this.inputBackColor = '';
        this.inputTextColor = '';
        this.errorColor = '';
        this.textColor = '';
        this.successColor = '';
        this.mainColor = '';
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.accentColor = '';
        this.linkColor = '';
        this.loadingSpinner = false;
        this.keyword = 'formattedName';
        this.dropdownInFocusDialNumber = false;
        this.placeholderText = '';
        this.showPassword = false;
        this.showPasswordAgain = false;
        this.dialCodeError = false;
        this.mobileDisabled = true;
        this.phoneDialCodeError = false;
        this.phoneUniqueError = false;
        this.validateUniquePhone = 1;
        this.questionnaire = [];
        this.questions = [];
        this.activeOptions = false;
        this.questionnaire_label = "Kako ste čuli za nas?";
        this.selectedDropdownOption = '';
        this.selectedReason = null;
        this.customOption = false;
        this.customReasonText = '';
        this.lang = '';
        this.showReferralInstruction = false;
        this.registerData = {
            email: undefined,
            password: undefined,
            recaptchaToken: undefined,
            dialCode: undefined,
            mobile: undefined,
            username: undefined,
            userType: undefined,
            passwordAgain: undefined,
            refCode: undefined,
            subId: undefined,
            termsConsent: false,
            privacyPolicyConsent: false,
            contractProposalConsent: false
        };
        /** The active version of every legal document, keyed by type (terms, privacy_policy, contract_proposal_individual, contract_proposal_company). */
        this.legalDocuments = null;
        this.themeService.getTheme().subscribe((data) => {
            this.secondColor = this.themeService.getStyleAttribute('secondary_text_color');
            this.inputBackColor = this.themeService.getStyleAttribute('input_background_color');
            this.inputTextColor = this.themeService.getStyleAttribute('input_text_color');
            this.textColor = this.themeService.getStyleAttribute('text_color');
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.mainColor = this.themeService.getStyleAttribute('main_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
            this.errorColor = this.themeService.getStyleAttribute('error_color');
            this.linkColor = this.themeService.getStyleAttribute('link_color');
        });
        this.validateUniquePhone = Number(this.webSettingsService.getWebSetting('ACCOUNT.VALIDATE_UNIQUE_PHONE'));
        this.setUserType(0);
        this.countriesForm = this.formBuilder.group({
            countriesAutoComplete: ''
        });
        this.getChosenLanguageSubscription = this.languageService.getChosenLanguage().subscribe((lang) => {
            this.lang = lang ? lang : 'en';
            this.getOnboardingQuestionary();
        });
        this.route.queryParams.subscribe((params) => {
            if (params.r) {
                this.registerData.refCode = params.r;
            }
            if (params.subid) {
                this.registerData.subId = params.subid;
            }
        });
    }
    ngOnInit() {
        var _a;
        if ((_a = this.data) === null || _a === void 0 ? void 0 : _a.registerData) {
            this.registerData = this.data.registerData;
        }
        if (this.data.providerToken && this.data.provider) {
            this.registerData['credential'] = this.data.providerToken;
            this.registerData['provider'] = this.data.provider;
        }
        this.registerData.email = this.data.email;
        this.registerData.username = this.data.email;
        this.setRecaptchaToken();
        this.initRecaptchaRefreshInterval();
        this.getCountries();
        this.loadLegalDocuments();
    }
    loadLegalDocuments() {
        this.httpClient.get('user/registration/legal-documents').subscribe((documents) => {
            this.legalDocuments = documents;
        }, () => {
            this.legalDocuments = null;
        });
    }
    /** The contract proposal the user consents to depends on the chosen user type. */
    contractProposalDocument() {
        if (!this.legalDocuments) {
            return null;
        }
        return this.registerData.userType === 1
            ? this.legalDocuments.contract_proposal_company
            : this.legalDocuments.contract_proposal_individual;
    }
    consentsGiven() {
        return this.registerData.termsConsent === true
            && this.registerData.privacyPolicyConsent === true
            && this.registerData.contractProposalConsent === true;
    }
    ngOnDestroy() {
        if (this.getChosenLanguageSubscription) {
            this.getChosenLanguageSubscription.unsubscribe();
        }
        this.clearRecaptchaRefreshInterval();
    }
    initRecaptchaRefreshInterval() {
        const registerComponent = this;
        setInterval(function () {
            registerComponent.setRecaptchaToken();
        }, 2 * 60 * 1000);
    }
    setRecaptchaToken() {
        load(localStorage.getItem('recaptcha_site_key')).then((recaptcha) => {
            recaptcha.execute('submit').then((token) => {
                this.registerData.recaptchaToken = token;
            });
        });
    }
    clearRecaptchaRefreshInterval() {
        if (this.recaptchaRefreshInterval != null) {
            clearInterval(this.recaptchaRefreshInterval);
            this.recaptchaRefreshInterval = null;
        }
    }
    getOnboardingQuestionary() {
        this.httpClient.get('user/onboardingquestionnaire?language_name=' + this.lang).subscribe((data) => {
            this.questionnaire = data[0];
            this.questions = this.questionnaire.questionnaire.questions;
            this.questionnaire_label = this.questions[0].language_value.value;
        });
    }
    openSelectOptions() {
        this.activeOptions = !this.activeOptions;
    }
    fillData(data) {
        this.selectedDropdownOption = data.language_value[0].value;
        this.selectedReason = data;
        if (data.customizable == 1) {
            this.customOption = true;
        }
        else {
            this.customOption = false;
        }
        this.activeOptions = false;
        if (data.language_value[0].value === "Preporuka prijatelja" || data.language_value[0].value === "Recomendation from a friend") {
            this.showReferralInstruction = true;
        }
        else {
            this.showReferralInstruction = false;
        }
    }
    generateQuestionnairePayload() {
        if ((this.selectedReason.customizable === 1) && (this.customReasonText.length === 0)) {
            return null;
        }
        const answers = Array();
        const optionsAnswers = Array();
        const optionPosition = this.questions[0].question_options.findIndex((option) => option.id === this.selectedReason.id);
        const temp = {
            question_option_id: this.selectedReason.id,
            customizable_value: (this.selectedReason.customizable === 1) ? this.customReasonText : null,
            option_position: optionPosition !== -1 ? optionPosition + 1 : null
        };
        optionsAnswers.push(temp);
        const temp2 = {
            question_id: this.questions[0].id,
            options_answers: optionsAnswers
        };
        answers.push(temp2);
        return {
            questionnaire_id: this.questionnaire.questionnaire_id,
            answers,
            language_name: this.lang
        };
    }
    getCountries() {
        this.httpClient.get('user/registrationcountries').subscribe((data) => {
            var _a;
            this.countries = data;
            this.countries.forEach(country => {
                country.formattedName = country.name + ' ' + country.dial_code;
            });
            if (this.registerData.dialCode) {
                this.countriesForm.get('countriesAutoComplete').patchValue((_a = this.countries.find(country => country.dial_code === this.registerData.dialCode)) === null || _a === void 0 ? void 0 : _a.formattedName);
                this.mobileDisabled = false;
            }
        });
    }
    setdialCode(item) {
        this.registerData.dialCode = item.dial_code;
        this.mobileDisabled = this.registerData.dialCode === undefined || this.registerData.dialCode === null || this.registerData.dialCode === '';
    }
    comparePassword() {
        return this.passwordsSame = this.registerData.password === this.registerData.passwordAgain;
    }
    setUserType(type) {
        this.registerData.userType = type;
    }
    checkIfUserTypeSelected() {
        if (this.registerData.userType === null || this.registerData.userType === undefined) {
            this.userTypeError = true;
            return false;
        }
        return true;
    }
    checkPasswordStrength() {
        const passRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,64}$/;
        if (passRegex.test(this.registerData.password) === false) {
            this.passwordNotStrong = true;
            return false;
        }
        else {
            this.passwordNotStrong = false;
            return this.comparePassword();
        }
    }
    onFocusedDialCode(e) {
        this.dropdownInFocusDialNumber = e;
        this.dialCodeError = !e && !this.registerData.dialCode;
    }
    onDialCodeclear(e) {
        this.registerData.dialCode = '';
        this.registerData.mobile = '';
        this.mobileDisabled = true;
    }
    togglePassword(event) {
        this.showPassword = !this.showPassword;
        event.preventDefault();
    }
    togglePasswordAgain(event) {
        this.showPasswordAgain = !this.showPasswordAgain;
        event.preventDefault();
    }
    checkPhoneNumber() {
        this.phoneError = false;
        this.phoneUniqueError = false;
        this.phoneDialCodeError = false;
        if (!this.utility.checkPhone(this.registerData.dialCode + this.registerData.mobile)) {
            this.phoneError = true;
            return false;
        }
        return this.httpClient.post('user/checkmobilenumber', {
            mobilenumber: this.registerData.dialCode + this.registerData.mobile,
            isCompany: this.registerData.userType
        }).subscribe((result) => {
            return true;
        }, (error) => {
            if (error.error.message === 'MOBILE_NUMBER_ALREADY_EXISTS' && this.validateUniquePhone === 0) {
                return true;
            }
            else if (error.error.message === 'MOBILE_NUMBER_ALREADY_EXISTS' && this.validateUniquePhone === 1) {
                this.phoneUniqueError = true;
                return false;
            }
            else {
                this.phoneError = true;
                return false;
            }
        });
    }
    checkIfFormIsValid() {
        const optionalFields = ['refCode', 'subId'];
        return Object.entries(this.registerData)
            .some(([key, value]) => {
            if (optionalFields.includes(key)) {
                return false;
            }
            if (this.registerData['credential'] && (key === 'password' || key === 'passwordAgain')) {
                return false;
            }
            return value === undefined || value === null || value === '';
        })
            || this.passwordNotStrong || !this.passwordsSame || this.phoneError || this.phoneDialCodeError
            || this.phoneUniqueError || this.selectedDropdownOption === '' || (this.customOption && this.customReasonText.length === 0)
            || !this.consentsGiven();
    }
    register() {
        if (this.checkIfUserTypeSelected() && (!this.registerData['providerToken'] || this.checkPasswordStrength()) && this.checkPhoneNumber()) {
            this.registerData.mobile = this.registerData.dialCode + this.registerData.mobile;
            if (this.registerData.userType === 1) {
                this.modal.destroy();
                this.openBaseCompanyInformationModal({ registerData: this.registerData });
            }
            else {
                this.registerUser(this.registerData);
            }
        }
    }
    registerUser(registerData) {
        this.loadingSpinner = true;
        const questionnaire = this.generateQuestionnairePayload();
        if (questionnaire) {
            registerData.questionnaire = questionnaire;
        }
        this.httpClient.post('user/registration', registerData).subscribe((result) => {
            if (result['auth_token']) {
                this.auth.setLoggedIn(true);
                this.auth.setToken(result['auth_token'], result['token_duration']);
                localStorage.setItem('refresh_token', result['refresh_token']);
                if (localStorage.getItem('auth_token')) {
                    this.auth.fetchUser().then(() => {
                        const user = JSON.parse(localStorage.getItem('user'));
                        localStorage.setItem('defaultCurrency', this.webSettingsService.getWebSetting('DEFAULT_CURRENCY'));
                        localStorage.setItem('allowedDecimalPlaces', this.webSettingsService.getWebSetting('WALLET.NUMBER_OF_DECIMALS_BUY_SELL'));
                        if (user.wallet_blocked) {
                            localStorage.setItem('ResetMfaMessageModalComponentShownOnStart', '0');
                        }
                        const array = [];
                        array.push({
                            event: 'loggedIn',
                            userId: user.id
                        });
                        this.googleAnalyticsService.pushGAEvents(array);
                        this.verifyPageShownOnLogin = user.settings.verify_page_shown_on_login;
                        if (this.verifyPageShownOnLogin) {
                            this.router.navigateByUrl('/verify');
                        }
                        else if (this.webSettingsService.getWebSetting('DEFAULT_ROUTE') !== '') {
                            this.router.navigateByUrl(this.webSettingsService.getWebSetting('DEFAULT_ROUTE'));
                        }
                        this.loadingSpinner = false;
                        this.modal.destroy();
                    });
                }
            }
            else {
                this.loadingSpinner = false;
                this.modal.destroy();
                this.compService.openModal(SuccessfulRegistrationComponent);
            }
            this.setRecaptchaToken();
        }, (error) => {
            this.setRecaptchaToken();
            this.loadingSpinner = false;
        });
    }
    openBaseCompanyInformationModal(data) {
        this.compService.openModal(GeneralCompanyInformationComponent, {
            registerData: data.registerData,
            baseCompanyData: data.baseCompanyData
        }, (success) => {
            this.openCompanyLocationInfoModal(success);
        }, (error) => {
            this.compService.openModal(EmailGoogleRegistrationComponent, { registerData: error.registerData });
        });
    }
    openCompanyLocationInfoModal(data) {
        const questionnaire = this.generateQuestionnairePayload();
        let finalRegisterData;
        if (questionnaire) {
            finalRegisterData = Object.assign(Object.assign({}, this.registerData), { questionnaire });
        }
        else {
            finalRegisterData = this.registerData;
        }
        this.compService.openModal(CompanyLocationInformationComponent, {
            registerData: finalRegisterData,
            baseCompanyData: data.baseCompanyData
        }, (success) => { }, (error) => {
            this.openBaseCompanyInformationModal(error);
        });
    }
    alreadyHave() {
        this.modal.destroy();
        this.compService.openModal(LoginComponent);
    }
    close() {
        document.body.className = '';
        this.router.navigateByUrl('/');
        this.modal.destroy();
    }
};
RegisterComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: ComponentService },
    { type: UtilityService },
    { type: DomSanitizer },
    { type: WebsiteThemeService },
    { type: Router },
    { type: TranslateObjectPipe },
    { type: WebClientService },
    { type: FormBuilder },
    { type: LanguageService },
    { type: ActivatedRoute },
    { type: AuthService },
    { type: GoogleAnalyticsService }
];
RegisterComponent = __decorate([
    Component({
        selector: 'ecd-register',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./register.component.html")).default
    })
], RegisterComponent);
export { RegisterComponent };
